import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { memberStatusParser } from '#validation';
import { WorkspaceCryptoResponseSchema } from '#web-service-api/workspace/response';
export const AcceptableInvitationResponseSchema = z.object({
    id: z.string(),
    publicKey: z.string(),
    ePrivateKeyByInvitationSecret: z.string(),
    sInvitationByAdminKey: z.string(),
    sAdminPublicKeyByInvitationKey: z.string(),
    workspace: WorkspaceCryptoResponseSchema,
    member: z
        .object({
        id: z.string(),
        status: memberStatusParser,
        publicKey: z.string().nullish(),
        ePrivateKeyByInvitationKey: z.string().nullish(),
        sMemberByInvitationKey: z.string().nullish(),
    })
        .optional(),
});
export class AcceptableInvitationResponseDto extends createZodDto(AcceptableInvitationResponseSchema) {
}
